
import React from 'react';

import DataPanel from './DataPanel';

import { TabPanel } from '../../core';

const renderTabPanel = (props) => {
    return (
        <TabPanel key={props.name} name={props.name} iconName={props.iconName} title={props.title}>
            <DataPanel
                appActions={props.appActions}
                appConfig={props.appConfig}
            />
        </TabPanel>
    );
}

export default renderTabPanel;
